import { render } from "./tempLandingPage.vue?vue&type=template&id=6e0d8e0c"
import script from "./tempLandingPage.vue?vue&type=script&lang=js"
export * from "./tempLandingPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__